export const ru = {
    'add-minus-word': 'Добавить в минус-фразы'
};
